<template>
  <div>
    <app-header class="header" :title="title" back-type="back-app" />
    <div class="course_page">
      <div class="flexbox course_box">
        <img class="course_avtarUrl" :src="courseInfo.avtarUrl" alt="" />
        <div class="course_name">{{ courseInfo.teacherName }}</div>
        <!-- <div class="course_job">{{courseInfo.teacherName}}</div> -->
      </div>
      <div class="course_content" v-html="courseInfo.brief"></div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import Body from '@/mixins/body'
export default {
  mixins: [Body],
  data() {
    return {}
  },
  computed: {
    ...mapGetters('payment/courseInfo', ['courseInfo', 'title']),
    ...mapGetters('args', ['shareCode', 'teacherId'])
  },
  created() {
    this.$store.dispatch('payment/courseInfo/getInfo', {
      teacherId: this.teacherId
    })
  },

  methods: {}
}
</script>

<style lang="less" scoped>
.course_page {
  .course_box {
    flex-direction: column;
    padding: 0.8rem 0 1rem;
    background-color: #f8f8f8;
    .course_avtarUrl {
      display: block;
      width: 2.4rem;
      height: 2.4rem;
      border-radius: 50%;
    }
    .course_name {
      font-size: 0.36rem;
      font-weight: 700;
      margin: 0.4rem 0 0.24rem;
    }
    .course_job {
      color: #666666;
      font-size: 0.28rem;
    }
  }
  .course_content {
    padding: 0.48rem;
    background-color: #fff;
    font-size: 0.28rem;
    color: #666666;
    line-height: 1.3;
   /deep/ img {
      max-width: 100%;
      width: auto;
      height: auto;
    }
  /deep/  p {
      margin: 14px 0;
    }
  }
}
</style>
